export default __webpack_public_path__ + "static/media/spid-idp-intesaid.50c24788.png";